function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.391 341.67c2.233-11.622 9.731-19.72 17.794-27.729 39.731-39.471 79.257-79.149 118.89-118.72 1.042-1.04 2.483-1.681 3.886-2.606-1.816-1.9-2.726-2.89-3.676-3.84-41.451-41.457-82.912-82.903-124.36-124.37C-.498 50.974-1.4 29.998 10.772 15.509 22.891 1.083 43.918-1.689 59.343 9.177c1.923 1.355 3.672 2.994 5.346 4.657 41.059 40.789 82.098 81.598 123.13 122.41 1.236 1.229 2.363 2.565 3.831 4.167 1.33-1.262 2.398-2.232 3.416-3.251 40.839-40.834 81.639-81.706 122.52-122.5 20.13-20.086 53.166-12.3 61.005 14.486 3.942 13.471 1.105 25.707-8.986 35.811-40.896 40.953-81.836 81.862-122.77 122.78-1.055 1.054-2.22 1.997-3.73 3.346 1.555 1.574 2.817 2.87 4.099 4.145 41.483 41.245 82.947 82.512 124.48 123.71 7.841 7.778 12.115 16.935 11.916 28.04-.339 18.925-15.543 33.947-34.478 34.383-12.797.294-23.379-3.928-32.519-13.139-40.412-40.73-81.076-81.21-121.63-121.8-1.051-1.052-1.864-2.341-3.763-4.762-1.344 2.123-1.949 3.604-2.99 4.647-41.243 41.312-82.524 82.585-123.8 123.86-12.661 12.66-34.266 14.972-49.314 5.318-7.714-4.95-11.718-12.329-13.907-20.936-.208-.819-.536-1.607-.809-2.409v-10.48",
  fillRule: "nonzero"
});

var SvgCloseMenu = function SvgCloseMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 384 384",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close_menu.c813c5d2.svg";
export { ForwardRef as ReactComponent };